import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_WALLET_PAYMENT_PRIMARY_EXPERIMENT = defineFcm('promote_wallet_payment_primary_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				exclusion_group_experiment_id: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Promote Page',
		deprecated: 'FCM no longer in use — safe to delete after 2026-10-08.',
		description:
			'Controls the experiment for promoting wallet payment as the primary CTA on the promote page. exclusion_group_experiment_id is the member id to check this experiment against in FCM_PROMOTE_PAGE_EXCLUSION_GROUP; leave unset to run unconditionally, bypassing the exclusion group entirely.',
		template: {
			experimentName: '',
			exclusion_group_experiment_id: 'promote_wallet_payment_primary_experiment',
		},
	});
